// Import 3rd-party dependencies
import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubSink } from 'subsink';

// Import project-specific dependencies
import { FavoriteService } from '@app/services/favorites/favorites.service';
import { HUB_FAVORITES_COMPONENT_CONSTS } from '@app/config/constants';

@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.css']
})
export class HubFavoritesComponent implements OnInit, OnDestroy {
  private subs: SubSink;
  @Output() newItemEvent = new EventEmitter<string>();

  favList$ = this.favoriteService.favorites$;
  consts = HUB_FAVORITES_COMPONENT_CONSTS;

  constructor(public addDialog: MatDialog, private favoriteService: FavoriteService) {}

  ngOnInit(): void {
    this.subs = new SubSink();
    this.favoriteService.getFavoriteList();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  openLink(url: string): void {
    window.open(url, '_blank');
  }

  viewAll(): void {
    this.newItemEvent.emit();
  }
}
